export var ExistsInEpic;
(function (ExistsInEpic) {
    ExistsInEpic["YES"] = "YES";
    ExistsInEpic["NO"] = "NO";
    ExistsInEpic["UNKNOWN"] = "UNKNOWN";
    ExistsInEpic["PENDING"] = "PENDING";
    ExistsInEpic["NA"] = "NA";
})(ExistsInEpic || (ExistsInEpic = {}));
//# sourceMappingURL=ExistsInEpic.js.map